<template>
    <mu-pagination :total="5" :current="2">
    </mu-pagination>
</template>
<script>
export default {
    name: 'pagination'
}
</script>



// WEBPACK FOOTER //
// pagination.vue?ea69c4f8